@use '../../styling/colors.scss' as *;

.ButtonWrapper {
  font-size: 0;
}

.PopOut {
  margin-top: 2px; // moves popout nearer to its trigger
  z-index: 9999; // otherwise the tooltips hide behind Mosaic Window
}

.PopOutBorder {
  background-color: $theme-color-background;
  border: 1px solid $theme-color-borders;
  box-shadow: 0 4px 16px 0 $color-dropdown-box-shadow;
  border-radius: 6px;
}

.PopOutBorderless {
  margin-top: 8px;
  margin-bottom: 8px;
}

.WithArrow {
  margin: 10px;
}

.Arrow {
  position: absolute;
  width: 10px;
  height: 10px;

  &::before {
    content: '';
    margin: auto;
    display: block;
    width: 0;
    height: 0;
    border-style: solid;
  }

  &[data-placement*='bottom'] {
    top: -10px;
    left: -10px;

    &::before {
      margin-left: -5px;
      border-width: 0 10px 10px 10px;
      border-color: transparent transparent $color-secondary-purple transparent;
    }
  }

  &[data-placement*='top'] {
    bottom: -10px;
    left: -10px;

    &::before {
      margin-left: -5px;
      border-width: 10px 10px 0 10px;
      border-color: $color-secondary-purple transparent transparent transparent;
    }
  }

  &[data-placement*='right'] {
    left: -10px;

    &::before {
      margin-top: -5px;
      border-width: 10px 10px 10px 0;
      border-color: transparent $color-secondary-purple transparent transparent;
    }
  }

  &[data-placement*='left'] {
    right: -10px;

    &::before {
      margin-top: -5px;
      border-width: 10px 0 10px 10px;
      border-color: transparent transparent transparent $color-secondary-purple;
    }
  }
}